import { action, computed, observable, runInAction } from 'mobx';
import ErrorUtil from '../error/ErrorUtil';
import API from '../util/ApiUtil';
import { FetchStatus } from '../util/FetchStatus';
import RootStore from './RootStore';
import SsoStore from './SsoStore';

export default class CouponStore {
  @observable accessor telia1CouponCodes: string[] = [];
  @observable accessor previousCustomerId: number = null;
  @observable accessor status: FetchStatus = FetchStatus.UNINITIALIZED;

  private ssoStore: SsoStore;

  public constructor(rootStore: RootStore) {
    this.ssoStore = rootStore.ssoStore;
  }

  public async loadTelia1Coupons() {
    const customerId = this.ssoStore.customerId;
    if (!customerId) {
      runInAction(() => {
        this.status = FetchStatus.FETCHED;
      });
      this.resetCouponState();
      return Promise.resolve();
    }
    if ([FetchStatus.FETCHED, FetchStatus.FETCHING].includes(this.status) && this.isSameCustomer(customerId)) {
      return Promise.resolve();
    }
    runInAction(() => {
      this.previousCustomerId = customerId;
      this.status = FetchStatus.FETCHING;
    });
    return this.fetchTelia1Promotions();
  }

  private async fetchTelia1Promotions() {
    try {
      const response = await API.get('/product/telia1-coupon-names');
      runInAction(() => {
        this.telia1CouponCodes = response.data || [];
        this.status = FetchStatus.FETCHED;
      });
    } catch (e) {
      runInAction(() => {
        ErrorUtil.pushErrorToTeliaRumAndLog(e);
        this.status = FetchStatus.ERROR;
        this.resetCouponState();
      });
    }
  }

  @computed
  public get isFetching() {
    return this.status === FetchStatus.FETCHING;
  }

  @computed
  public get isErrored() {
    return this.status === FetchStatus.ERROR;
  }

  @action
  private resetCouponState() {
    this.previousCustomerId = null;
    this.telia1CouponCodes = [];
  }

  private isSameCustomer(customerId: number) {
    return (!customerId && !this.previousCustomerId) || customerId === this.previousCustomerId;
  }
}
